exports.errorNotify = (obj, icon, error) => {
  let text = '';
  if(typeof error === 'string') {
    text = error;
  } else {
    if(error.response === undefined) {
      text = 'Contact admin, something went wrong'
    } else {
      text = error.response.data.message
    }
  }
  
  obj.open({
    message: "Error",
    description: text,
    icon: icon,
  });
}

exports.successNotify = (obj, icon, text) => {
  obj.open({
    message: "Completed",
    description: text,
    icon: icon,
  });
}